import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from '@/routes/AppRouter'
import { OfflineIndicator } from '@/components/OfflineIndicator'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { syncManager } from '@/lib/sync-manager'
import { offlineStorage } from '@/lib/offline-storage'
import { useAuthStore } from '@/stores/auth.store'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

export function App() {
  const loadUser = useAuthStore((state) => state.loadUser)

  useEffect(() => {
    // Initialize offline storage
    offlineStorage.init()

    // Start auto-sync
    syncManager.startAutoSync()

    // Load user from Cognito session
    loadUser()
  }, [loadUser])

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRouter />
          <OfflineIndicator />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
